import React from 'react';
import PropTypes from 'prop-types';
import MetaField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { SSN_CHARS } from 'Components/UI/MaskedInput';
import { noop } from 'Helpers/PropTypes';

const SocialSecurityField = ({ attr, onChange, ...rest }) => {
  const { handleChange } = useMetaLayoutContext();

  const replaceAndChange = (value) => {
    const cleanValue = value.replace(SSN_CHARS, '');
    handleChange(attr, cleanValue);
    return onChange(cleanValue);
  };

  return <MetaField attr={attr} onChange={replaceAndChange} {...rest} />;
};

SocialSecurityField.defaultProps = {
  onChange: noop,
};

SocialSecurityField.propTypes = {
  onChange: PropTypes.func,
};

export default SocialSecurityField;
